import {FreightToOtherAddress, PickUp} from 'assets';
import {FreightOption} from 'components/customer/Auth/store/userSlice';
import {Depot} from 'components/manufacturer/DepotSettings/depotApi';
import {useAppContext} from 'contexts/ApplicationContext';
import {DispatchMethod} from 'hooks/Job/Job';
import {useMemo} from 'react';
import {getColoredImage} from 'shared/helpers';
import {DepotFreightOptions} from 'store/customer/depotSlice';
import {useTheme} from 'styled-components';

export interface DispatchMethod {
    value: number;
    id: string;
    label: string;
    selectedImage: string;
    image: string;
    display: number | undefined;
    selectable: boolean;
}

export const getDispatchMethod = (option?: FreightOption) => {
    switch (option) {
        case 'FREIGHT_SPECIFIC_ADDRESS':
        case 'FREIGHT_MY_ADDRESS':
            return DispatchMethod.FREIGHT_CUSTOM_ADDRESS;
        default:
            return DispatchMethod.PICKUP;
    }
};

export const useDispatchMethods = (depotSelected?: Depot) => {
    const {userProfile} = useAppContext();
    const theme = useTheme();

    const dispatchMethods = useMemo<DispatchMethod[]>(() => {
        let displayPickup = false;
        let displayDelivery = false;

        if (depotSelected) {
            switch (depotSelected.freight_pickup_option) {
                case DepotFreightOptions.PICKUP:
                    displayPickup = true;
                    break;
                case DepotFreightOptions.DELIVERY:
                    displayDelivery = true;
                    break;
                case DepotFreightOptions.PICKUP_AND_DELIVERY:
                    displayPickup = true;
                    displayDelivery = true;
                    break;
            }
        } else {
            displayPickup = true;
            displayDelivery = true;
        }

        const PICKUP = [
            {
                value: DispatchMethod.PICKUP,
                id: 'dispatch-pickup',
                label: 'Pickup',
                selectedImage: getColoredImage(
                    PickUp,
                    '#204380',
                    theme.colors.primary?.main ?? '#204380'
                ) as string,
                image: getColoredImage(
                    PickUp,
                    '#204380',
                    theme.colors.secondary?.main ?? '#204380'
                ) as string,
                display: userProfile?.manufacturerPickupAvailable,
                selectable: displayPickup,
            },
        ];

        const DELIVERY = [
            {
                value: DispatchMethod.FREIGHT_CUSTOM_ADDRESS,
                id: 'dispatch-specific',
                label: 'Freight to address',
                selectedImage: getColoredImage(
                    FreightToOtherAddress,
                    '#204380',
                    theme.colors.primary?.main ?? '#204380'
                ) as string,
                image: getColoredImage(
                    FreightToOtherAddress,
                    '#204380',
                    theme.colors.secondary?.main ?? '#204380'
                ) as string,
                display: userProfile?.manufacturerFreightAvailable,
                selectable: displayDelivery,
            },
        ];

        return [...PICKUP, ...DELIVERY];
    }, [userProfile, depotSelected]);

    return {
        dispatchMethods,
    };
};
